import React, { Component } from 'react';
import { gsap } from 'gsap';

import { scenesPropTypes } from './prop-types';
import animationData from '../../lotties/11';
import SceneHeading from '../SceneHeading';
import SceneContent from '../SceneContent';
import SceneSlides from '../SceneSlides';
import Slide from '../Slide';
import SlideSeparator from '../SlideSeparator';
import SlideText from '../SlideText';
import Story from '../Story';
import Figure from '../Figure';
import TikTokPlayer from '../Players/TikTokPlayer';

/**
 * Scene11
 */

class Scene11 extends Component {
  constructor(props) {
    super(props);

    /** Refs */
    this.element = React.createRef();
    this.heading = React.createRef();
    this.tween = React.createRef();
    this.slides = this.props.data.slides.map(() => React.createRef());
    this.slidesTweens = [];
    this.stories = [];
    this.medias = [];
    this.props.data.slides.forEach((slide, index) => {
      this.slidesTweens[index] = {};
      if (slide.type === 'figure' && slide.number) {
        this.slidesTweens[index].figure = React.createRef();
      }
      if (slide.type === 'story' && slide.title && slide.text) {
        this.stories[index] = React.createRef();
      }
      if (slide.type === 'media' && slide.video) {
        this.medias[index] = React.createRef();
      }
    });
  }

  /**
   * Invoked after the component is mounted
   */
  componentDidMount() {
    /** Setup a GSAP Tween for each story and media */
    this.stories.map((story, index) => (this.slidesTweens[index].story = gsap.from(story.current, { opacity: 0, duration: 1, paused: true })));
    this.medias.map((media, index) => (this.slidesTweens[index].media = gsap.from(media.current.element.current, { opacity: 0, duration: 1, paused: true })));

    /** Mount the slides tweens to the Scene timeline */
    this.props.mountSlides(this.slides, this.tween.current);
  }

  /**
   * Invoked multiple times when a slide is entering the screen
   *
   * @param {number} direction (1:up)|(-1:down) - The scroll direction
   * @param {number} index - The index of the slide
   */
  onSlideEnter(direction, index) {
    /** Load the tiktoks */
    if (this.medias[index]) {
      console.info(this.medias[index].current);
      this.medias[index].current.play();
    }
  }

  /**
   * Invoked multiple times when a slide is leaving the screen
   *
   * @param {number} direction (1:up)|(-1:down) - The scroll direction
   * @param {number} index - The index of the slide
   */
  onSlideLeave(direction, index) {
    /** Unload the tiktoks */
    if (this.medias[index]) {
      this.medias[index].current.pause();
    }
  }

  render() {
    return (
      <div ref={this.element} className="scene-wrapper">
        <SceneHeading ref={this.heading} title={this.props.title} animationData={animationData} />
        <SceneContent layout={this.props.data.layout}>
          <SceneSlides ref={this.tween} align={this.props.data.align} length={this.props.data.slides.length}>
            {this.props.data.slides.map((slide, index) => (
              <Slide key={index} ref={this.slides[index]} type={slide.type} align={slide.align} layout={slide.layout}>
                {slide.separator && (
                  <>
                    <SlideSeparator text={slide.separator} layout="white" icon="tiktok" />
                  </>
                )}
                {slide.type === 'figure' && slide.number && (
                  <p>
                    <Figure
                      ref={this.slidesTweens[index].figure}
                      number={slide.number}
                      prefix={slide.prefix}
                      color={slide.color}
                      icon={slide.icon}
                      iconColor="white"
                      text={slide.text}
                      textColor="white"
                      link={slide.link}
                    />
                  </p>
                )}
                {slide.type === 'text' && slide.text && (
                  <div className="text-big">
                    <SlideText text={slide.text} />
                  </div>
                )}
                {slide.type === 'story' && (
                  <>
                    <Story ref={this.stories[index]} subTitle={slide.title} text={slide.text} picture={slide.picture} link={slide.link} />
                  </>
                )}
                {slide.type === 'media' && slide.video && (
                  <>
                    <TikTokPlayer ref={this.medias[index]} url={slide.video} poster={slide.picture} legend={slide.title} count />
                  </>
                )}
              </Slide>
            ))}
          </SceneSlides>
        </SceneContent>
      </div>
    );
  }
}

Scene11.propTypes = scenesPropTypes;

export default Scene11;
